import { IntlShape } from 'react-intl/src/types';

export const hasTranslationMessage = (intl: IntlShape, messageKey: string) =>
  !!intl.messages[messageKey];
